export default __webpack_public_path__ + "static/media/gl-5.e22fd4e7.png";